<template>
  <div
    class="text-ontick-carbon-900 flex w-full flex-col overflow-hidden text-sm shadow-md dark:text-gray-300"
  >
    <div
      class="dark:bg-ontick-graphite-500 grid w-full grid-cols-2 bg-gray-50 text-center"
    >
      <!-- <p class="td text-gray-500 dark:text-gray-400">#{{ data.license_id }}</p> -->
      <p class="td">{{ data.product_name }}</p>
      <ontick-button class="m-2" @click.native="active = true"
        >Detalhes</ontick-button
      >
    </div>

    <portal to="modal">
      <ontick-modal :open="active" size="small" @close="active = false">
        <div
          class="text-ontick-carbon-900 flex flex-col space-y-4 pb-6 dark:text-gray-300"
        >
          <h2
            class="border-ontick-steel-300 dark:border-ontick-steel-500 border-b-2 pb-3 text-xl font-bold"
          >
            Informações
          </h2>
          <dl class="modal-row">
            <dt>ID:</dt>
            <dd>#{{ data.license_id }}</dd>
          </dl>
          <dl class="modal-row">
            <dt>Produto:</dt>
            <dd>{{ data.product_name }}</dd>
          </dl>
          <dl class="modal-row">
            <dt>Tipo:</dt>
            <dd>
              {{
                data.license_type === "PLAN"
                  ? "Plano"
                  : data.license_type === "EXTENSION"
                  ? "Extensão"
                  : "Produto"
              }}
            </dd>
          </dl>
          <dl class="modal-row">
            <dt>Status:</dt>
            <dd :class="statusColor(data.license_status)">
              {{ data.license_status }}
            </dd>
          </dl>
          <dl class="modal-row">
            <dt>Data de compra:</dt>
            <dd>{{ data.license_create_date }}</dd>
          </dl>
          <dl class="modal-row">
            <dt>Próxima cobrança:</dt>
            <dd>{{ data.license_next_charge }}</dd>
          </dl>
          <dl class="modal-row" v-if="data.license_remaining_days !== '-'">
            <dt>Tempo restante:</dt>
            <dd>{{ data.license_remaining_days }} dias</dd>
          </dl>
          <dl class="modal-row">
            <dt>Preço:</dt>
            <dd>{{ data.license_price | currency }}</dd>
          </dl>
          <dl class="modal-row" v-if="data.action">
            <dt>Ação:</dt>
            <dd>
              <ontick-switch-component
                v-if="
                  data.license_type === 'EXTENSION' &&
                  data.license_status === 'ATIVA'
                "
                :active="data.active"
                @switch="$emit('action', data)"
              />
              <span v-else>
                <button
                  class="text-ontick-blue-600 text-sm"
                  @click="$emit('action', data)"
                >
                  {{ data.action }}
                </button>
              </span>
            </dd>
          </dl>
        </div>
      </ontick-modal>
    </portal>
  </div>
</template>

<script>
import ontickSwitchComponent from "../../../../shared/components/basic/ontick-switch.component.vue";

export default {
  components: { ontickSwitchComponent },
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    statusColor(status) {
      const colorList = {
        ATIVA: "text-ontick-green-500",
        CANCELADA: "text-ontick-red-500",
        PENDENTE: "text-ontick-yellow-500",
        EXPIRADA: "text-gray-500",
      };
      return colorList[status];
    },
  },
};
</script>

<style lang="scss" scoped>
.th {
  @apply px-4 py-2 font-bold;
}
.td {
  @apply self-center px-4 py-2;
}
.modal-row {
  @apply grid grid-cols-2;
  dt {
    @apply font-bold;
  }
}
</style>
